import moment from 'moment';
import swal from 'sweetalert2';
import { AGREEMENT_URL, CONSTANTS, PRIVACY_URL } from '../constants/constants';

/**
 * Sets subscription status for all type of subscriptions (Braitree, Apple, Alexa)
 *
 * @param  {Array}  subscription  The user's subscriptions from fetchMysubscriptions action
 * @return {string}  Subsciption status. Possible values are {subscribed|nosubscribed}
 */
const setSubscriptionStatus = (subscription) => {
  if (subscription.active) {
    return 'subscribed';
  }

  return 'nosubscribed';
};

/**
 * Converts a string with date format from YYYY-MM-DDTHH:mm:ss.sssZ to MM/dd/yyyy
 * UTC is considered
 * Beware! It won't work in some browsers if another format is provided.
 *
 * @param  {string}  date  string represents date. Supported only format compliant with ECHAScript date specification (YYYY-MM-DDTHH:mm:ss.sssZ)
 * @return {string}  string represents date in format MM/dd/yyyy
 */
const convertDate = (date) => {
  const utcDate = new Date(date);

  // convert UTC date to local date in string format MM/dd/yyyy
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };

  return utcDate.toLocaleDateString('en-US', options);
};

/**
 * Format size in bytes to KB, MB, GB etc according to decimal digits.
 * Source: https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
 * @param  {number}   bytes      Number of bytes to be formated
 * @param  {number}   decimals   Number of digits that the size will be formated
 *                               Default is 2.
 * @return {string}              The formated size as sting with the unit of measurement e.g. "10 MB"
 */
const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

const validUrl = (value) =>
  value &&
  !/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i.test(
    value
  )
    ? false
    : true;

const getDuration = (duration) => {
  if (duration !== undefined && typeof duration === 'string') {
    if (duration.includes(':')) {
      return getDurationInSeconds(duration);
    }

    if (duration.includes(';')) {
      duration = duration.replaceAll(';', ':');
      return getDurationInSeconds(duration);
    }

    if (duration.includes('.')) {
      const durationParts = duration.split('.').length;
      return durationParts > 2
        ? getDurationInSeconds(duration.replaceAll('.', ':'))
        : parseInt(duration, 10);
    }

    return parseInt(duration, 10);
  }
  if (typeof duration === 'number') {
    return parseInt(duration, 10);
  } else {
    return 0;
  }
};

const getProgress = (progress, duration) => {
  if (duration !== 0) {
    return (progress / duration) * 100;
  }
  return 0;
};

const getDurationInSeconds = (duration) => {
  const durationParts = duration.split(':');

  // 00
  if (durationParts.length < 2) {
    return parseInt(duration, 10);
  }

  // 00:10
  if (durationParts.length < 3) {
    return parseInt(durationParts[0], 10) * 60 + parseInt(durationParts[1], 10);
  }

  // 00:10:10
  if (durationParts.length < 4) {
    return (
      parseInt(durationParts[0], 10) * 3600 +
      parseInt(durationParts[1], 10) * 60 +
      parseInt(durationParts[2], 10)
    );
  }
};

const secondsToHms = (d) => {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);
  var s = Math.floor((d % 3600) % 60);
  var hDisplay = h > 9 ? h : '0' + h;
  var mDisplay = m > 9 ? m : '0' + m;
  var sDisplay = s > 9 ? s : '0' + s;
  return hDisplay + ':' + mDisplay + ':' + sDisplay;
};

const secondsToHm = (d) => {
  d = Number(d);
  var h = Math.floor(d / 3600);
  var m = Math.floor((d % 3600) / 60);
  var hDisplay = h > 9 ? h : '0' + h;
  var mDisplay = m > 9 ? m : '0' + m;
  return hDisplay + ':' + mDisplay;
};

const formatDate = (cell) => {
  const formatedDate = cell.replace(/\//g, '-').replace(/,/g, '');
  return <div>{formatedDate}</div>;
};

const sortDate = (a, b, order) => {
  if (order === 'desc') {
    return moment(b.date, 'MM-DD-YYYY') - moment(a.date, 'MM-DD-YYYY');
  }
  return moment(a.date, 'MM-DD-YYYY') - moment(b.date, 'MM-DD-YYYY');
};

var sliderSettings = {
  dots: true,
  speed: 500,
  slidesToShow: 7,
  slidesToScroll: 7,
  initialSlide: 0,
  infinite: false,
  adaptiveHeight: true,
  responsive: [
    {
      breakpoint: 1824,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
  ]
};

const sortByName = (a, b, order) => {
  a = `${a.documentName}`;
  b = `${b.documentName}`;
  if (order === 'desc') {
    return a.localeCompare(b);
  } else {
    return b.localeCompare(a);
  }
};

const sortDatedocumentab = (a, b, order) => {
  let a_ = a.releaseDate != '' ? a.releaseDate : 0;
  let b_ = b.releaseDate != '' ? b.releaseDate : 0;
  if (order === 'desc') {
    return moment(b_) - moment(a_);
  }
  return moment(a_) - moment(b_);
};

const truncateText = (text, maxLength) => {
  if (text === null) {
    return '';
  }
  if (text?.length < maxLength) {
    return text;
  }
  if (text?.length > maxLength) {
    return text.substring(0, maxLength) + '...';
  }
};

/**
 * Converts a string with date format from YYYY-MM-DDTHH:mm:ss.sssZ to MM/dd/yyyy hh:mm:ss
 * UTC is considered
 * Beware! It won't work in some browsers if another format is provided.
 *
 * @param  {string}  date  string represents date. Supported only format compliant with ECHAScript date specification (YYYY-MM-DDTHH:mm:ss.sssZ)
 * @return {string}  string represents date in format MM/dd/yyyy  hh:mm:ss
 */
const convertDateTime = (date) => {
  const utcDate = new Date(date);

  // convert UTC date to local date in string format MM/dd/yyyy
  const options = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  };

  return (
    utcDate.toLocaleDateString('en-US', options) +
    ' ' +
    utcDate.toLocaleTimeString('en-US')
  );
};

const convertSecondsToTime = (sec) => {
  const dateObj = new Date(sec * 1000);
  const hours = dateObj.getUTCHours() === 0 ? '' : dateObj.getUTCHours();
  const minutes = dateObj.getUTCMinutes() === 0 ? '' : dateObj.getUTCMinutes();
  const seconds = dateObj.getUTCSeconds() === 0 ? '' : dateObj.getUTCSeconds();

  const h =
    hours.toString() === '0' || hours.toString() === ''
      ? ''
      : hours.toString().padStart(2, '0') + ':';
  const m =
    minutes.toString() === '0'
      ? ''
      : minutes.toString() === ''
      ? '00:'
      : minutes.toString().padStart(2, '0') + ':';
  const s =
    seconds.toString() === '0'
      ? ''
      : seconds.toString() === ''
      ? '00'
      : seconds.toString().padStart(2, '0');

  const timeString = h + m + s;

  return timeString;
};

const clearText = (array, setFlags) => {
  const updatedArray = array?.map((item) => ({
    ...item,
    text: item.text?.replace(/\r?\n|\r/g, '')
  }));
  return setFlags(updatedArray);
};

const splitName = (name) => {
  const names = name?.split(' ');
  if (names?.length > 0) {
    const firstNameInitial = names[0][0];
    const lastNameInitial = names.length > 1 && names[1][0] ? names[1][0] : '';
    return `${firstNameInitial}${lastNameInitial}`.toUpperCase();
  }
  return null;
};

const showAlert = (title, content) => {
  swal({
    imageUrl: CONSTANTS.swalLogo,
    title: `<div class="titleModal">${title}</div>`,
    html: `<p class="contentModal">${content}</p>`,
    showConfirmButton: true,
    showCloseButton: true,
    background: '#121C24',
    allowOutsideClick: false
  });
};

/**
 * Checks if a given file name ends with any of the specified valid extensions.
 *
 * @param  {string} fileName - The name of the file to check.
 * @param  {string[]} validExtensions - An array of valid file extensions to check against.
 * @return {boolean} - Returns true if the file name ends with any of the valid extensions, otherwise false.
 */
const checkFileExtension = (fileName, validExtensions) => {
  const lowerCaseFileName = fileName.toLowerCase();
  return validExtensions.some((extension) =>
    lowerCaseFileName.endsWith(extension)
  );
};

const showAlertForError = (error) => {
  swal({
    imageUrl: CONSTANTS.swalLogo,
    title: '<div class="titleModal">We\'re sorry there was an error.</div>',
    html: `<p class="contentModal">${error.message}</p>`,
    showConfirmButton: false,
    showCloseButton: true,
    background: '#121C24',
    allowOutsideClick: false
  }).catch(swal.noop);
};

const displayNotification = (message, options) => {
  swal({
    imageUrl: CONSTANTS.swalLogo,
    html: message,
    background: '#121C24',
    ...options
  });
};

export const getCopyrightHtml = () => {
  return `
    <footer class="footerModal">
      <div class="linksInflo">
        <span style="color:#a1a1a1">
          © Copyright ${new Date().getFullYear()} Inflo, Inc.
        </span>
        <a class="linksInflo" href="${PRIVACY_URL}">Privacy Policy</a>  |  
        <a class="linksInflo" href="${AGREEMENT_URL}">License Agreement</a>
      </div>
    </footer>
  `;
};

export {
  checkFileExtension,
  clearText,
  convertDate,
  convertDateTime,
  convertSecondsToTime,
  displayNotification,
  formatBytes,
  formatDate,
  getDuration,
  getProgress,
  secondsToHm,
  secondsToHms,
  setSubscriptionStatus,
  showAlert,
  showAlertForError,
  sliderSettings,
  sortByName,
  sortDate,
  sortDatedocumentab,
  splitName,
  truncateText,
  validUrl
};
